<script setup>
import { defineProps } from "vue";
defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Confirmar Eliminación",
  },
  message: {
    type: String,
    default: "¿Estás seguro de que deseas eliminar este ítem?",
  },
});
</script>
<template>
  <transition name="fade">
    <div
      v-if="show"
      class="modal fade show"
      style="display: block; background: rgba(0, 0, 0, 0.5)"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ title }}</h5>
            <button
              type="button"
              class="btn-close"
              @click="$emit('cancel')"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p v-html="message"></p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-cancel"
              @click="$emit('cancel')"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-delete"
              @click="$emit('confirm')"
            >
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<style lang="scss" scoped>
@import "@/_scss/global/_variables.scss";
.btn-cancel {
  color: $ultra-white-color;
  background-color: $six-color;
  &:hover {
    background-color: transparentize($six-color, 0.2);
  }
}
.btn-delete {
  color: $ultra-white-color;
  background-color: $error2-color;
  &:hover {
    background-color: transparentize($error2-color, 0.2);
  }
}
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
